import { combineReducers } from "redux"

import {
  loading,
  activeImage,
  editConfirm,
  deleteConfirm,
  message,
  termModalShown,
  showGinaModal,
  error,
  errorCode,
  confirmMessageShown,
  confirmMessage,
} from "../interview/reducer"
import completion from "../completion/reducer"
import dashboard from "../dashboard/reducer"
import search from "../search/reducer"
import queues from "../interview/queues"
import chatList from "../interview/chatList"
import auth from "../auth/reducer"
import editor from "../editor/reducer"
import feedback from "../feedback/reducer"
import identifiers from "../identifiers/reducer"
import integration from "../integration/reducer"
import tutorials from "../interview/tutorials"
import account from "../account/reducer"
import { custom, theme, brand } from "../embed/reducer"
import simpleFlow from "../simpleFlow/reducer"
import payment from "../payment/reducer"
import visit from "../interview/visit"
import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

export const showLoadingScreen = setterReducer(false, t.SHOW_LOADING_SCREEN)
export const showCovid19AlertBanner = setterReducer(
  true,
  t.SHOW_COVID19_ALERT_BANNER
)
export const selectedLocale = setterReducer(null, t.SET_LOCALE)

const path = (state = "/", action) => {
  switch (action.type) {
    case "SET_PATH":
      return action.payload
    default:
      return state
  }
}

const modals = combineReducers({
  activeImage,
  confirmMessage,
  confirmMessageShown,
  deleteConfirm,
  editConfirm,
  error,
  errorCode,
  message,
  termModalShown,
  showGinaModal,
})

// please remember when adding a new reducer to position it alphabetically
const appReducer = combineReducers({
  account,
  auth,
  brand,
  chatList,
  completion,
  custom,
  dashboard,
  editor,
  feedback,
  identifiers,
  integration,
  loading,
  modals,
  path,
  payment,
  queues,
  search,
  selectedLocale,
  showCovid19AlertBanner,
  showLoadingScreen,
  simpleFlow,
  theme,
  tutorials,
  visit,
})

const rootReducer = (state, action) => {
  if (action.type === t.RESTORE) {
    return appReducer(action.snapshot, action)
  }

  return appReducer(state, action)
}

export { rootReducer as default }



// WEBPACK FOOTER //
// ./assets/redux/rootReducer.js